

































































































































































import Vue from 'vue'
import moment from 'moment'
import { Employee } from '@/model/companyStructure/Employee'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import {
  DELETE_NOTE_ATTACHMENT,
  FETCH_NOTE_ATTACHMENT_LIST,
  SAVE_NOTE,
  SAVE_NOTE_ATTACHMENT
} from '@/store/action-types'
import { NoteType } from '@/model/addresses/NoteType'
import _ from 'lodash'
import { Note } from '@/model/addresses/Note'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { NotePayload, SaveNoteAttachmentPayload } from '@/types/payload'
import {
  AdressenNotizenIndexResponse,
  DeleteNoteAttachmentResponse,
  GetNoteAttachmentListResponse,
  SaveNoteAttachmentResponse
} from '@/types/service-response'
import ImageGalleryDialog from '@/components/master-data/address/ImageGalleryDialog.vue'

interface EventFile extends Event {
  target: HTMLInputElement & EventTarget
}

interface AddressEmployeeWithFullName {
  id: number | undefined
  fullName: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inSaveProgress: boolean

  title: string
  validationRules: Array<Function>
  selectedAddressEmployee: number | undefined
  selectedResponsibleEmployee: number | undefined
  dateStartIso: string
  dateEndIso: string
  alreadyDone: number
  selectedAuthor: number | undefined
  isPrivate: boolean
  noteType: number | undefined
  noteTitle: string
  noteText: string
  showImageGallery: boolean
  imageList: string[]
  imageIdList: number[]
  deleteLoading: boolean
}

export default Vue.extend({
  name: 'NotesDialog',

  components: {
    ImageGalleryDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    addressEmployee: Array as () => Array<AddressEmployee>,
    employeeList: Array as () => Array<Employee>,
    notesData: Object as () => Note,
    noteTypeList: Array as () => Array<NoteType>,
    addressId: Number,
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()
    const today = new Date()
    // @ts-ignore
    const todayIso = this.formatDateIso(today)

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inSaveProgress: false,

      title: '',
      validationRules: [required],
      selectedAddressEmployee: undefined,
      selectedResponsibleEmployee: undefined,
      dateStartIso: todayIso,
      dateEndIso: todayIso,
      alreadyDone: 0,
      selectedAuthor: undefined,
      isPrivate: false,
      noteType: undefined,
      noteTitle: '',
      noteText: '',
      showImageGallery: false,
      imageList: [],
      imageIdList: [],
      deleteLoading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    addressEmployeeList (): AddressEmployeeWithFullName[] {
      return this.addressEmployee.map((item: AddressEmployee) => {
        return {id: item.id, fullName: `${item.firstName} ${item.name}`}
      })
    },

    dateStartFormatted (): string {
      const date: Date = new Date(this.dateStartIso)
      return this.formatDate(date)
    },

    dateEndFormatted (): string {
      const date: Date = new Date(this.dateEndIso)
      return this.formatDate(date)
    }
  },

  methods: {
    onFieldStartChange (): void {
      if(moment(this.dateStartIso, 'YYYY-MM-DD') > moment(this.dateEndIso, 'YYYY-MM-DD'))
      this.dateEndIso = this.dateStartIso
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    formatDate (date: Date): string {
      return moment(date).format('DD.MM.YYYY')
    },

    onAddImageClick (): void {
      //@ts-ignore
      this.$refs.fileInput.click()
    },

    onFileChange (e: EventFile): void {
      if (e && e.target.files) {
        const files: File | undefined = e.target.files[0]

        if (files) {
          const reader = new FileReader()

          reader.readAsDataURL(files)
          reader.onload = (e: any) => {
            if (e.target && e.target.result) {
              if(this.notesData && this.notesData.id) {
                let type: string = e.target.result.split('/')[1].split(';')[0]
                let image = e.target.result.split(',')[1]

                const payload: SaveNoteAttachmentPayload = {
                  NoteId: this.notesData.id!,
                  File: image,
                  FileExtension: type
                }

                this.saveNoteAttachment(payload)
              } else {
                this.imageList.push(e.target.result)
              }

              /*const img = new Image()
              // @ts-ignore
              img.src = e.target.result
              img.onload = () => {
                const elem = document.createElement('canvas')
                /*const scaleFactor = 200 / img.width
                elem.width = 200
                elem.height = img.height * scaleFactor*/
                /*elem.width = img.width
                elem.height = img.height
                const ctx = elem.getContext('2d')

                //ctx!.drawImage(img, 0, 0, 200, img.height * scaleFactor)
                ctx!.drawImage(img, 0, 0, img.width, img.height)
                ctx!.canvas.toBlob((blob: any) => {
                  new File([blob], 'image', {
                    //type: 'image/png',
                    lastModified: Date.now()
                  })
                }, 'image/jpeg', 1)
                this.imageList.push(elem.toDataURL('image/jpeg', 1))
              }*/
            }
          }
        }
      }
    },

    onShowImageClick (): void {
      this.showImageGallery = true
    },

    onCloseImageGalleryDialog (): void {
      this.showImageGallery = false
    },

    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onDeleteFromImageList (item: number): void {
      this.imageList.splice(item, 1)
      if(this.imageList.length === 0) {
        this.onCloseImageGalleryDialog()
      }
    },

    async onDeleteFromImageIdList (item: number): Promise<void> {
      const imageNumber: number = this.imageIdList[item]

      try {
        this.deleteLoading = true
        let response: DeleteNoteAttachmentResponse = await this.$store.dispatch(DELETE_NOTE_ATTACHMENT, imageNumber)
        this.deleteLoading = false
        if(!response.IsError && response.Deleted) {
          this.imageIdList.splice(item, 1)
          if(this.imageList.length === 0) {
            this.onCloseImageGalleryDialog()
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.deleteLoading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {

        const addressEmployee: AddressEmployeeWithFullName | undefined = this.addressEmployeeList.find((employee: AddressEmployeeWithFullName) => employee.id === this.selectedAddressEmployee)

        const payload: NotePayload = {
          id: this.notesData ? this.notesData.id ? this.notesData.id : null : null,
          selectedAddressEmployeeId: this.selectedAddressEmployee ? this.selectedAddressEmployee : null,
          selectedAddressEmployeeName: addressEmployee ? addressEmployee.fullName : null,
          selectedResponsibleEmployee:  this.selectedResponsibleEmployee ? this.selectedResponsibleEmployee : null,
          dateStartIso:  this.dateStartIso,
          dateEndIso:  this.dateEndIso,
          alreadyDone:  this.alreadyDone,
          selectedAuthor:  this.selectedAuthor ? this.selectedAuthor : null,
          isPrivate:  this.isPrivate,
          noteType:  this.noteType ? this.noteType : null,
          noteTitle:  this.noteTitle,
          noteText:  this.noteText,
          addressId: this.addressId,
          action: this.notesData ? this.notesData.id ? 'Update ' : 'Insert' : 'Insert'
        }

        this.saveNote(payload)

      }
    },

    async saveNote (payload: NotePayload): Promise<void> {
      this.inSaveProgress = true
      try {
        let response: AdressenNotizenIndexResponse = await this.$store.dispatch(SAVE_NOTE, payload)
        if(!response.IsError && response.NoteId) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.imageList.forEach((item: string) => {
            let type: string = item.split('/')[1].split(';')[0]
            let image = item.split(',')[1]

            const payload: SaveNoteAttachmentPayload = {
              NoteId: response.NoteId,
              File: image,
              FileExtension: type
            }
            this.saveNoteAttachment(payload)
          })
          this.$emit('dialogSaved')
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    async fetchNoteAttachmentList (): Promise<void> {
      try {
        let response: GetNoteAttachmentListResponse = await this.$store.dispatch(FETCH_NOTE_ATTACHMENT_LIST, this.notesData.id)
        if(!response.IsError) {
          if(response.Data) {
            this.imageIdList = response.Data
          }
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async saveNoteAttachment (payload: SaveNoteAttachmentPayload): Promise<void> {
      try {
        let response: SaveNoteAttachmentResponse = await this.$store.dispatch(SAVE_NOTE_ATTACHMENT, payload)
        if(!response.IsError && response.AttachmentId) {
          this.imageIdList.push(response.AttachmentId)
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted (): void {
    if(this.notesData && this.notesData.id) {
      this.title = this.$t('masterData.addresses.editNote').toString()
      const noteData: Note = _.cloneDeep(this.notesData)

      this.selectedAddressEmployee = noteData.addressEmployeeId
      this.selectedResponsibleEmployee = noteData.responsibleEmployee
      this.dateStartIso = moment(noteData.dateStartIso, "DD.MM.YYYY HH:mm:ss").format('YYYY-MM-DD')
      this.dateEndIso = moment(noteData.dateEndIso, "DD.MM.YYYY HH:mm:ss").format('YYYY-MM-DD')
      this.alreadyDone = noteData.alreadyDone
      this.selectedAuthor = noteData.author
      this.isPrivate = noteData.isPrivate
      this.noteType = noteData.noteType
      this.noteTitle = noteData.noteTitle
      this.noteText = noteData.noteText

      this.fetchNoteAttachmentList()

    } else {
      this.title = this.$t('masterData.addresses.addNote').toString()
      this.selectedResponsibleEmployee = this.currentUserId
      this.selectedAuthor = this.currentUserId
    }
  }
})
